import { createStore } from "effector";
import {
  ContactHandler,
  ContactUpdateField,
} from "@type/core/contact/contact.types";
import { setContactField } from "@state/contact/ContactsEvents";

export const contactStore = createStore<ContactHandler>({
  contactForm: {},
}).on<ContactUpdateField[]>(
  setContactField,
  (state: ContactHandler, payload: ContactUpdateField[]) => {
    return {
      ...state,
      contactForm: {
        ...state.contactForm,
        ...payload.reduce(
          (obj, contactUpdateField) => ({
            ...obj,
            [contactUpdateField.field]: contactUpdateField.value,
          }),
          {},
        ),
      },
    };
  },
);
